import { createAsyncThunk } from "@reduxjs/toolkit";
// import { showMessage } from "react-native-flash-message";
import { toast } from "react-toastify";
import apiInstance from "../../config/api";
import { updateReelsCount } from "../user/userReducer";
// import { MaterialIcons, MaterialCommunityIcons } from "@expo/vector-icons";
// import font from "../../constant/font";
// import colors from "../../constant/colors";


export const getUserReels = createAsyncThunk('reels/user-reels', async (userId) => {
    try {
        const request = await apiInstance.get(`/file/api/reels/${userId}`)
        const response = request.data
        console.log('get user reels response; ', response)
        if (response.status === 'success') {
            return response.reels
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getMyReels = createAsyncThunk('reels/personal-reels', async (_, { getState }) => {
    try {
        const state = getState()
        const { userData } = state.user
        const userId = userData?.userId
        const request = await apiInstance.get(`/file/api/reels/${userId}`)
        const response = request.data

        if (response.status === 'success') {
            return response.reels
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log('error getting my reels; ', error)
        throw new Error(error.message)
    }
})


export const getAllReels = createAsyncThunk('reels/get-all', async () => {
    try {
        const request = await apiInstance.get('/api/reels/all')
        const response = request.data
        if (response.status === 'success') {
            return response.reels
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getFriendsReels = createAsyncThunk('reels/get-friends', async () => {
    try {
        const request = await apiInstance.get('/api/reels/friends')
        const response = request.data
        if (response.status === 'success') {
            return response.reels
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})


export const getSingleReelsById = async (postId) => {
    try {
        const request = await apiInstance.get(`/api/reels/single/${postId}`)
        const response = request.data
        // console.log('single reel response', response)
        if (response.status === 'success') {
            return response.reel
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
}

export const searchReels = createAsyncThunk('reels/search', async (searchQuery) => {
    try {
        const request = await apiInstance.get(`/api/reels/search${searchQuery}`)
        const response = request.data
        if (response.status === 'success') {
            return response.reels
        } else {
            console.log('error searching reels', response.message)
        }
    }
    catch (error) {
        console.log('error searching reels', error.message)
    }
})

export const getReelsSearchPreview = createAsyncThunk('reels/search/preview', async () => {
    try {
        const request = await apiInstance.get('/api/reels/preview')
        const response = request.data
        if (response.status === 'success') {
            return response.reels
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const likeReels = createAsyncThunk('reels/like', async (reelId) => {
    try {
        const request = await apiInstance.post(`/api/reels/${reelId}/like`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const unlikeReels = createAsyncThunk('reels/unlike', async (reelId) => {
    try {
        const request = await apiInstance.post(`/api/reels/${reelId}/unlike`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const saveReels = createAsyncThunk('reels/save', async ({ reelId, reel }) => {
    try {
        const request = await apiInstance.post(`/api/save-reels/${reelId}/save`)
        const response = request.data
        if (response.status === 'success') {
            toast.success("Reels saved successfully!");
            return { message: response.message, reel }
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const unsaveReels = createAsyncThunk('reels/unsave', async (reelId) => {
    try {
        const request = await apiInstance.post(`/api/save-reels/${reelId}/unsave`)
        const response = request.data
        if (response.message === 'Reel unsaved successfully') {
            toast.success("Reels unsaved!");
            return reelId
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getSavedReels = createAsyncThunk('reels/get-saved-reels', async (_, { getState }) => {
    try {
        const state = getState()
        const { userData } = state.user
        const { userId } = userData ?? {}
        // console.log('my Id; ', userId)
        const request = await apiInstance.get(`/api/save-reels/${userId}/saved-reels`)
        const response = request.data
        console.log("saved reels response; ", response)
        if (response.status === 'success') {
            return response.savedReels
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        console.log("save reels error ; ", error.message)
        throw new Error(error.message)
    }
})

export const getReelsComment = createAsyncThunk('reels/get-comment', async ({ reelId }) => {
    try {
        const request = await apiInstance.get(`/api/reels/comments/${reelId}`)
        const response = request.data
        if (response.status === 'success') {
            return response.data
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const postReelsComment = createAsyncThunk('reels/comment', async ({ reelId, comment }) => {
    try {
        const request = await apiInstance.post(`/api/reels/comments/${reelId}`, comment)
        const response = request.data
        if (response.status === 'success') {
            return response.comment
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const deleteReelsComment = createAsyncThunk('reels/comment/delete', async (commentId) => {
    try {
        const request = await apiInstance.delete(`/api/reels/comments/${commentId}`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const likeReelsComment = createAsyncThunk('reels/comment/like', async (commentId) => {
    try {
        const request = await apiInstance.post(`/api/reels/comments/${commentId}/like`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const unlikeReelsComment = createAsyncThunk('reels/comment/unlike', async (commentId) => {
    try {
        const request = await apiInstance.delete(`/api/reels/comments/${commentId}/unlike`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const getReelsCommentReplies = createAsyncThunk('reels/comment/replies', async (commentId) => {
    try {
        const request = await apiInstance.get(`/api/reels/comments/${commentId}/replies`)
        const response = request.data
        if (response.message === 'Replies retrieved successfully') {
            return response.replies
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const replyReelsComment = createAsyncThunk('reels/comment/replies/create', async ({ commentId, reply }) => {
    try {
        const request = await apiInstance.post(`/api/reels/comments/${commentId}/reply/reply`, reply)
        const response = request.data
        console.log('reels reply response: ', response)
        if (response.message === 'Reply created successfully') {
            return response.reply
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

export const deleteReelsCommentReplies = createAsyncThunk('reels/comment/replies/delete', async (replyId) => {
    try {
        const request = await apiInstance.delete(`/api/reels/comments/${replyId}`)
        const response = request.data
        if (response.status === 'success') {
            return response.message
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

// ============== DELETE REEL FUNCTIONALITY ==============

export const deleteSingleReel = createAsyncThunk('reels/delete-single', async (postId, { dispatch, getState, rejectWithValue }) => {
    try {
        const request = await apiInstance.delete(`/file/api/reels/single/${postId}`)
        const response = request.data
        console.log('delete single reel response: ', response)

        if (response.status === 'success') {
            toast.success("Reel deleted successfully!");

            // Update reels count in user state
            dispatch(updateReelsCount({ actionType: "delete" }));

            return {
                message: response.message,
                postId: response.data.postId,
                reel: response.data
            }
        } else {
            toast.error(`Failed to delete reel: ${response.message}`);
            return rejectWithValue(response.message)
        }
    }
    catch (error) {
        console.log('error deleting reel: ', error)
        if (error.response?.status === 404) {
            toast.error("No post found for this user.");
            return rejectWithValue("No post found for this user.")
        } else {
            toast.error(`Delete failed: ${error.message}`);
            return rejectWithValue(error.message)
        }
    }
})

export const deleteAllUserReels = createAsyncThunk('reels/delete-all', async (_, { dispatch, getState, rejectWithValue }) => {
    try {
        const request = await apiInstance.delete('/file/api/reels')
        const response = request.data
        console.log('delete all reels response: ', response)

        if (response.status === 'success') {
            toast.success("All reels deleted successfully!");

            // Get count of deleted reels
            const deletedCount = response.posts?.length || 0;

            // Update reels count in user state (subtract all deleted)
            dispatch(updateReelsCount({
                actionType: "deleteAll",
                count: deletedCount
            }));

            return {
                message: response.message,
                posts: response.posts
            }
        } else {
            toast.error(`Failed to delete reels: ${response.message}`);
            return rejectWithValue(response.message)
        }
    }
    catch (error) {
        console.log('error deleting all reels: ', error)
        if (error.response?.status === 404) {
            toast.error("There are no reels for this user.");
            return rejectWithValue("There are no reels for this user.")
        } else {
            toast.error(`Delete all failed: ${error.message}`);
            return rejectWithValue(error.message)
        }
    }
})

// Add delete reel thunks to exports